<div class="min-h-full bg-gray-50 text-gray-800 px-4 py-10">
  <div class="max-w-2xl mx-auto">
    <div class="bg-white border border-gray-200 rounded-lg p-6">
      <div class="flex items-start gap-3">
        <i class="ri-lock-line text-2xl text-red-600 mt-0.5"></i>
        <div class="flex-1">
          <h1 class="text-lg font-semibold text-gray-900">
            @if (reason === 'unauthenticated') {
              You are not signed in
            } @else {
              You do not have access to this page
            }
          </h1>

          <p class="text-sm text-gray-600 mt-1">
            @if (reason === 'unauthenticated') {
              Tracer could not find an active session, so it stopped before loading
              <span class="font-mono break-all">{{ from }}</span>
              .
            } @else {
              Tracer refused
              <span class="font-mono break-all">{{ from }}</span>
              for this account.
            }
          </p>
        </div>
      </div>

      <!-- The point of this page: say exactly what was checked. A blank
           resource-role list is the answer most of the time. -->
      <dl class="mt-5 text-sm border-t border-gray-200 pt-4 space-y-2">
        <div class="flex gap-2">
          <dt class="text-gray-500 w-32 shrink-0">Checked as</dt>
          <dd class="font-mono break-all">{{ signedIn ? identity : 'no session' }}</dd>
        </div>
        <div class="flex gap-2">
          <dt class="text-gray-500 w-32 shrink-0">Keycloak realm</dt>
          <dd class="font-mono break-all">{{ realm }}</dd>
        </div>

        @if (requiredRole) {
          <div class="flex gap-2">
            <dt class="text-gray-500 w-32 shrink-0">Role required</dt>
            <dd class="font-mono break-all">{{ requiredRole }}</dd>
          </div>
        }

        @if (signedIn) {
          <div class="flex gap-2">
            <dt class="text-gray-500 w-32 shrink-0">Realm roles</dt>
            <dd class="font-mono break-all">
              {{ realmRoles.length ? realmRoles.join(', ') : 'none' }}
            </dd>
          </div>
          <div class="flex gap-2">
            <dt class="text-gray-500 w-32 shrink-0">Client roles</dt>
            <dd class="font-mono break-all">
              @if (resourceRoles.length) {
                @for (entry of resourceRoles; track entry.client) {
                  <div>{{ entry.client }}: {{ entry.roles }}</div>
                }
              } @else {
                none
              }
            </dd>
          </div>
        }
      </dl>

      @if (signedIn && !resourceRoles.length) {
        <p class="mt-4 text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded p-3">
          This token carries no client roles at all. That usually means the Keycloak realm's
          <span class="font-mono">default-roles-&lt;realm&gt;</span>
          composite is incomplete rather than anything being wrong with your account — worth
          checking before requesting permissions.
        </p>
      }

      <div class="mt-6 flex flex-wrap items-center gap-2">
        @if (!signedIn) {
          <button type="button" class="btn btn-sm" (click)="signIn()">Sign in</button>
        }
        <a class="btn btn-sm btn-outline" [routerLink]="['/']">Back to home</a>
      </div>
    </div>
  </div>
</div>
